import { ScanMetadata } from '../../../../interfaces/scanMetadata';
import { getFilteredScansByInbodyType } from '../../../../utils/getFilteredScansByInbodyType/getFilteredScansByInbodyType';
import { ProgressReportFormValues } from '../ProgressReportModal.settings';

export const getDefaultFormValue = (
  scansMetadata: ScanMetadata[],
): ProgressReportFormValues => {
  const newestScan = scansMetadata[0];

  if (!newestScan) {
    return { inbodyType: null, scanId: null, startScanId: null, endScanId: null };
  }

  const machineScans = getFilteredScansByInbodyType(scansMetadata, newestScan.inbodyType);
  const scanBeforeNewest = machineScans[1];

  return {
    inbodyType: newestScan.inbodyType,
    scanId: newestScan.scanId,
    startScanId: scanBeforeNewest?.scanId ?? null,
    endScanId: newestScan.scanId,
  };
};
